import { http } from '@/api/httpAxios'
import createURLParams from '@/api/datasource/createURLParams'
import { AxiosPromise } from 'axios'

export default class PublicationsAPI {
  public static getPublicationsListNew(
    limit: number,
    offset: number,
    sort: [] | null,
    filter: { [k: string]: any }
  ) {
    const params = createURLParams(limit, offset, sort, filter, false)
    return http.get('/publications/publications-new', { params })
  }

  public static getPublication(id: number) {
    return http.get(`/publications/${id}`)
  }

  public static getSimilarById(id: number) {
    return http.get(`/publications/similar/${id}`)
  }

  public static getSimilarByTitle(title: number, year: number) {
    return http.get(
      `/publications/title-similarity?title=${title}&year=${year}`
    )
  }

  public static getSimilarList(
    limit: number,
    offset: number,
    sort: [] | null,
    filter: { [k: string]: any },
    showHidden: boolean
  ) {
    const params = createURLParams(limit, offset, sort, filter, false)
    return http.get(`/publications/similar?show-hidden=${showHidden}`, {
      params
    })
  }

  public static setSimilarHidden(id1: number, id2: number, value: boolean) {
    return http.put(`/publications/similar`, {
      id1,
      id2,
      hidden: value
    })
  }

  public static updateFinancing(id: number, data: any) {
    return http.put(`/publications/${id}/funding`, data)
  }

  public static updatePublication(
    publicationId: number,
    data: any,
    userId?: number
  ): AxiosPromise {
    const params = new URLSearchParams()
    if (userId) {
      params.append('userId', userId.toString())
    }
    return http.put(`/publications/${publicationId}`, data, { params })
  }

  public static deletePublication(publicationId: number): AxiosPromise {
    return http.delete(`/publications/${publicationId}`)
  }
  public static assignPublication(
    publicationId: number,
    data: any
  ): AxiosPromise {
    return http.post(`/publications/${publicationId}/assign`, data)
  }

  public static getPublicationHistory(
    limit: number,
    offset: number,
    sort: [] | null,
    filter: { [k: string]: any },
    id: number
  ) {
    const params = createURLParams(limit, offset, sort, filter, false)
    return http.get(`/publications/${id}/history`, { params })
  }

  public static getAffiliationsConfig() {
    return http.get(`/publications/affiliation-filters`)
  }

  public static updateAffiliationsConfig(data: any) {
    return http.post(`/publications/affiliation-filters`, data)
  }

  public static getAffiliations() {
    return http.get(`/publications/affiliations`)
  }
}
